export const CONTACT_FORM_FIELDS = [
  {
    id: 1,
    name: "name",
    label: "Your_Name_Label",
    placeholder: "Eg_John",
    type: "input",
  },
  {
    id: 2,
    name: "email",
    label: "Email_Label",
    placeholder: "Eg_You_@_Example_com",
    type: "input",
  },
  {
    id: 3,
    name: "phoneNumber",
    label: "Phone_Number_Label",
    placeholder: "Eg_55_123_4567",
    type: "tel",
  },
  {
    id: 4,
    name: "message",
    label: "Message",
    placeholder: "Let_Us_Know_What_You_Need_Help_With",
    type: "textarea",
  },
];

export const CONTACT_FORM_FIELDS_HOMEPAGE = [
  {
    id: 1,
    name: "name",
    label: "Name",
    placeholder: "Eg_John",
    type: "input",
  },
  {
    id: 2,
    name: "email",
    label: "Email",
    placeholder: "Eg_You_@_Example_com",
    type: "input",
  },
  {
    id: 4,
    name: "message",
    label: "Message",
    placeholder: "Let_Us_Know_What_You_Need_Help_With",
    type: "textarea",
  },
];
